var _defs, _polygon, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaposte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.1 37.48 59.02 8.36 4.98 8.36 32.1 37.48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.12,30.26l19.82,23.24c.21-.53.21-1.07.21-1.87V12.36c0-1.34-.21-2.14-.83-2.94l-19.2,20.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.72,55.38c.42,0,.83.27,1.25.27h54.26c.42,0,.83-.27,1.04-.27l-19.82-23.51-7.72,8.28c-.42.53-1.04.53-1.25,0l-7.93-8.28L3.72,55.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.85,51.64c0,.8.21,1.34.42,1.87l19.82-23.24L2.89,9.43c-.63.8-1.04,1.6-1.04,2.94v39.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaposte);
export default __webpack_public_path__ + "static/media/laposte.b9a8468212d17c0004836f1cc2f7224a.svg";
export { ForwardRef as ReactComponent };